module.exports = __webpack_public_path__ + "img/support.be8937d6.svg";